import React, { Component } from "react";
import CaptchaService from "../services/captcha.service";
import ReCAPTCHA from "react-google-recaptcha";
import '../css/confirmation.css';
import axios from "axios";
import jwtDecode from "jwt-decode";
import ParamsService from "../services/params.service";
import card from "../img/identity-card-verified.png";
import Progressbar from "../common/progress_bar";
//Partie config mulesoft
const API_URL_MULE = process.env.REACT_APP_URL_API_MULE;
const AUTHORIZATION_USERNAME = process.env.REACT_APP_URL_API_MULE_USERNAME;
const AUTHORIZATION_PASSWORD = process.env.REACT_APP_URL_API_MULE_PASSWORD;
const authToken = btoa(`${AUTHORIZATION_USERNAME}:${AUTHORIZATION_PASSWORD}`);

const  cm = ParamsService.$_GET("cm");
const  from = ParamsService.$_GET("from");
const API_URL = process.env.REACT_APP_URL_API;
const USER_NAME_DEFAULT = process.env.REACT_APP_USER_NAME_DEFAULT;
const USER_PWD_DEFAULT = process.env.REACT_APP_USER_PWD_DEFAULT;
const KEY_CAPTCHA = process.env.REACT_APP_KEY_CAPTCHA;
export default class Profile extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onValid = this.onValid.bind(this);
    this.onReject = this.onReject.bind(this);
    this.state = {
      customer:"",
      KEY_CAPTCHA:KEY_CAPTCHA,
      cliccaptcha:false,
      etape:0,
      msgerrorcm:""
    };

  }

  loginDefault(cm) {
    var path="login_check";
    var uri = API_URL;
    if(process.env.REACT_APP_MULE==="1") {
      axios.defaults.headers.common['Authorization'] = `Basic ${authToken}`;
      path = "login";
      uri = API_URL_MULE;
    }
    return axios
        .post(uri + path, {
          "username":USER_NAME_DEFAULT,
          "password":USER_PWD_DEFAULT
        }, { mode: 'cors', credentials: 'include' })
        .then(response => {
          if (response.data.token) {
            const token = response.data.token;
            let user = [];
            user = jwtDecode(token);
            user['useremail'] = response.data.email;
            user['userid'] =  response.data.user_id;
            user['role'] = response.data.roles;
            this.setState({
              user:user,
              token:token
            });
            localStorage.setItem("token",token);
            this.setState({etape:this.state.etape+20});
            this.getContractsCustomer(cm, token);
          }
        });
  }

  getContractsCustomer(cm, token) {
    return axios.get(
        API_URL + 'haugazel/contracts_customer_token/' + cm,
        { headers: {
            Authorization: 'Bearer ' + token
          }
        })
        .then(response => {
          if (response.data && !response.data.error) {
            const  customer= JSON.stringify(response.data.customer);
            this.setState({
              customer:customer,
              etape:this.state.etape+70
            })

          }else{
            if(response.data.error){
              this.setState({
                    msgerrorcm: response.data.error
                  }
              )
            }
          }

          return response.data;
        });

  }

  onChange(value) {
    CaptchaService.validCaptcha(value).then(
        response => {
         if(response.data.success===true){
           this.setState({cliccaptcha:true});
         }else{
           this.setState({cliccaptcha:false});
         }

        },
        error => {
          this.setState({cliccaptcha: false});
        }
        );


  }
  onValid(){
    window.location.replace("/info_payment_cm/&cm="+cm+"&from="+from+"&check=1");
  }
  onReject(){
    window.location.replace("https://espace-client.ohm-energie.com/login");
  }
  componentDidMount() {
    localStorage.removeItem("user");
    if(cm){
      this.setState({cm: cm});
      this.loginDefault(cm);
    }
  }

  render() {
    let customer = "";
    if(this.state.customer){
      customer = JSON.parse(this.state.customer);

    }
    if(this.state.msgerrorcm){
      return(
          <div className="col-md-12">
            <header className="jumbotron">
              <h3>{this.state.msgerrorcm}.</h3>
            </header>
          </div>);
    }
    return (
        <div className="col-md-12">
        { (this.state.customer==="") &&
            <header className="jumbotron">
              <Progressbar bgcolor="#30ad71" progress={this.state.etape}  height={30} />
            </header>
      }

    {
      (this.state.customer !== "") &&
        <>
        <header className="jumbotron-customer">
          <div className="circle-container circle-customer">
            <div className="circle-text">
              <span>
                {customer.firstname[0] + customer.lastname[0]}
              </span>
            </div>
          </div>
          <div>
            <span className="name">
              { customer.firstname + " " + customer.lastname }
            </span>
          </div>
          <div className="trait"></div>
          <span className="cm">
            {customer.refCustomer}
          </span>
        </header>
        <div className="App">
          <div className="col-12 app-customer">
            <div className="confirmation">
              <div className="div-img-card">
                <img className="img-card" alt={"card"} src={card}/>
              </div>
              <div className="title-confirmation">
                <h3>Avant d'aller plus loin ,</h3>
                <h3>Êtes vous bien <span className='customer-name'>{customer.firstname + " " + customer.lastname}</span> ?</h3>
              </div>

              <label>
                <span>Veuillez cocher la case ci-dessous pour continuer.</span>
              </label>
              <div className="form-group">
                <ReCAPTCHA
                    sitekey={this.state.KEY_CAPTCHA}
                    onChange={this.onChange}
                    className="g-recaptcha"
                />
              </div>
              <div className="form-group">
                <button  onClick={this.onValid} id="yes" disabled={!this.state.cliccaptcha} className="btn-ohm btn btn-confirmation btn-primary"><span>Oui</span></button>
                <button  onClick={this.onReject} id ="no" disabled={!this.state.cliccaptcha} className="btn-ohm btn btn-confirmation btn-primary"><span>Non</span></button>
              </div>
            </div>
          </div>

        </div>
      </>


    }
        </div>

    );
  }
}
